var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBathroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00507 16.098H2.97999V17.1H2.00507V16.098Z",
    fill: "#8F90A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50738 16.098H5.4823V17.1H4.50738V16.098Z",
    fill: "#8F90A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00968 16.098H7.98461V17.1H7.00968V16.098Z",
    fill: "#8F90A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39504 13.9271H3.36996V14.9291H2.39504V13.9271Z",
    fill: "#8F90A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50738 13.9271H5.4823V14.9291H4.50738V13.9271Z",
    fill: "#8F90A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61971 13.9271H7.59464V14.9291H6.61971V13.9271Z",
    fill: "#8F90A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5564 11.3054H14.9877V5.92822C14.9877 2.65938 12.4 0 9.21938 0C6.03872 0 3.45108 2.65938 3.45108 5.92822V7.31756C2.64491 7.79129 2.06311 8.62388 1.91313 9.60205H0.900024V11.1885C0.900024 12.0632 1.59251 12.7749 2.44366 12.7749H7.54576C8.3969 12.7749 9.08939 12.0632 9.08939 11.1885V9.60205H8.07628C7.92631 8.62388 7.34447 7.79129 6.53834 7.31756V5.92822C6.53834 4.40889 7.74104 3.17285 9.21938 3.17285C10.6977 3.17285 11.9004 4.40889 11.9004 5.92822V17.1H14.9877V14.4782H15.5564C16.4075 14.4782 17.1 13.7665 17.1 12.8918C17.1 12.0171 16.4075 11.3054 15.5564 11.3054ZM8.11447 11.1885C8.11447 11.5107 7.85933 11.7729 7.54576 11.7729H2.44366C2.13009 11.7729 1.87495 11.5107 1.87495 11.1885V10.604H8.11447V11.1885ZM2.90642 9.60205C3.12779 8.62725 3.97975 7.89873 4.99471 7.89873C6.00967 7.89873 6.86162 8.62725 7.083 9.60205H2.90642ZM14.0128 16.098H12.8754V5.92822C12.8754 3.85642 11.2353 2.1709 9.21938 2.1709C7.20347 2.1709 5.56342 3.85642 5.56342 5.92822V6.95035C5.37896 6.91528 5.18891 6.89678 4.99471 6.89678C4.8005 6.89678 4.61046 6.91528 4.426 6.95035V5.92822C4.426 3.21186 6.5763 1.00195 9.21938 1.00195C11.8625 1.00195 14.0128 3.21186 14.0128 5.92822V16.098ZM15.5564 13.4763H14.9877V12.3073H15.5564C15.87 12.3073 16.1251 12.5695 16.1251 12.8918C16.1251 13.2141 15.87 13.4763 15.5564 13.4763Z",
    fill: "#8F90A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBathroom);
export default __webpack_public_path__ + "static/media/iconBathroom.d92fdda7.svg";
export { ForwardRef as ReactComponent };